
import { BaseService } from './base-service';

export class NotificationService extends BaseService {
  public async updateUserPushToken(token: string, platform: string): Promise<boolean> {
    if (token === null || token === undefined || token === '') {
      console.error('Invalid firebase token provided (empty)');
      return false;
    }
    
    if (this.heyUtils.firebaseToken === null) {
      this.heyUtils.firebaseToken = localStorage.getItem('firebaseToken');
    }
    
    if (this.heyUtils.firebaseToken === token) {
      console.debug('Firebase Token is already up to date, skiping call');
      return true;
    }
    
    try {
      localStorage.setItem('firebaseToken', token);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
      localStorage.clear();
    }
    
    const result = await this.callHeyApiTech('POST', `/v3/user/${this.heyUtils.user_id}/pushToken`, {
      "appCurrentVersion": "7777",
      "platform": platform.toLowerCase() === "android" ? "ANDROID" : "IOS",
      "type": "FIREBASE",
      "value": token
    });
    
    console.debug('Update push token result:', result);
    
    if (!result.success) {
      console.error('Failed to update push token:', result.error);
      return false;
    }
    
    return result.success;
  }
}
